<template>
  <div class="bag-dropdown-product-card">
    <UiHorizontalProductCard
      :brand-name="brandName"
      :data-checkoutable-id="checkoutableId"
      :data-line-item-id="lineItemId"
      :highlight-text="highlightText"
      :image-url="imageUrl"
      :product-name="productName"
      :variant-name="variantName"
      class="horizontal-product-card"
    />
    <div class="price-quantity-actions">
      <div class="price-quantity">
        <UiPrice v-if="price" v-bind="price" />

        <span class="quantity body-s">{{ quantityLabel }}: {{ quantity }}</span>
      </div>
      <div class="actions">
        <UiIcon
          name="delete-outlined"
          size="16px"
          @click="emit('remove-line-item', lineItemId)"
          :is-clickable="true"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UiHorizontalProductCard from '@sephora-asia/ui-horizontal-product-card/UiHorizontalProductCard.vue'
import UiPrice from '@sephora-asia/ui-price/UiPrice.vue'
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'
import type { BagDropdownProductCardProps } from './types'

interface Emits {
  (e: 'remove-line-item', value: string): void
}

defineProps<BagDropdownProductCardProps>()
const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.bag-dropdown-product-card {
  display: flex;
  gap: 16px;
  width: 100%;

  .horizontal-product-card {
    width: 100%;
  }

  .price-quantity-actions {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .price-quantity {
      display: flex;
      flex-direction: column;
      gap: 8px;
      text-align: right;

      .quantity,
      :deep(.price-container) {
        text-wrap: nowrap;
      }
    }

    .actions {
      text-align: right;
    }
  }
}
</style>
